// you can import modules from the theme lib or even from
// NPM packages if they support it…
import 'lazysizes';
import AOS from 'aos';

import $ from "jquery";

import 'featherlight';
import * as CookieConsent from "vanilla-cookieconsent";
import flatpickr from "flatpickr";
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';


import { searchProperties } from './search.js';
import { singleProperty } from './property.js';

//import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
//const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
//import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
//import AnimateOnPageLinks from "./components/AnimateOnPageLinks";


// Initialise our components on jQuery.ready…
// jQuery(function ($) {
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();
// });


$(document).on('click', '#mobile-menu-button', function (e) {
	$('#mobile-overlay').removeClass('hidden');
	$('.mobile-menu').removeClass('translate-x-full');
});

$(document).on('click', '#mobile-overlay, #mobile-menu-close-button', function (e) {
	$('#mobile-overlay').addClass('hidden');
	$('.mobile-menu').addClass('translate-x-full');
});


$(document).ready(function () {
	searchProperties();
	singleProperty();
	AOS.init();

	CookieConsent.run({
		guiOptions: {
			consentModal: {
				layout: "box",
				position: "bottom left",
				equalWeightButtons: true,
				flipButtons: false
			},
			preferencesModal: {
				layout: "box",
				position: "right",
				equalWeightButtons: true,
				flipButtons: false
			}
		},
		categories: {
			necessary: {
				readOnly: true
			},
			analytics: {
				enabled: true
			}
		},
		language: {
			default: "en",
			autoDetect: "browser",
			translations: {
				en: {
					consentModal: {
						title: "We value your privacy",
						description: "This website uses cookies to enhance your experience and improve our services. By continuing to browse, you agree to our use of cookies. We use functional cookies for the smooth operation of the website and analytics cookies via Google Analytics to understand how our site is used and how we can improve your experience.",
						acceptAllBtn: "Accept all",
						acceptNecessaryBtn: "Reject all",
						showPreferencesBtn: "Manage preferences",
						footer: ""
					},
					preferencesModal: {
						title: "Consent Preferences Center",
						acceptAllBtn: "Accept all",
						acceptNecessaryBtn: "Reject all",
						savePreferencesBtn: "Save preferences",
						closeIconLabel: "Close modal",
						serviceCounterLabel: "Service|Services",
						sections: [
							{
								title: "Cookie Usage",
								description: "This website uses cookies to enhance functionality and improve user experience. Cookies are small data files stored on your device. While some cookies are essential for the operation of this website, others help us understand how our site is used, enabling us to provide a better user experience."
							},
							{
								title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
								description: "These cookies are essential for the basic functionalities of the website and are automatically enabled when you use the site. They include cookies that help with site security, load balancing, and management of network traffic, ensuring efficient browsing.",
								linkedCategory: "necessary"
							},
							{
								title: "Analytics Cookies",
								description: "Analytics cookies help us improve our website by collecting and reporting information on its usage. By analysing this data, we can understand visitor behavior and enhance our site to offer a better user experience. These cookies collect information in a way that does not directly identify anyone. Your consent to use these cookies helps us to provide a more personalised and efficient service.",
								linkedCategory: "analytics"
							},
							{
								title: "More information",
								description: "For further details about our cookie policy or if you have any queries regarding how we handle cookies and your choices, please contact us."
							}
						]

					}
				}
			}
		}
	});
	document.addEventListener('aos:in', ({ detail }) => {
		console.log('animated in', detail);
	});

	document.addEventListener('aos:out', ({ detail }) => {
		console.log('animated out', detail);
	});
	

	$(".play-button-category").on("click", function () {
		// Create the video element and set attributes
		var videoSrc = $(this).data("video-src"); // Get the video source from the data attribute

		// Create the video element and set attributes
		var videoElement = document.createElement("video");
		videoElement.src = videoSrc;
		videoElement.autoplay = true;
		videoElement.loop = true;
		videoElement.muted = true;
		videoElement.classList.add("w-full", "h-full", "object-cover");

		// Append the video element to the video container
		var videoContainerParent = $(".video-container-parent");
		var videoContainer = $("#video-container");
		videoContainer.append(videoElement);
		videoContainerParent.slideDown(600, function () {
			// Scroll to the top of the video container
			$("html, body").animate({
				scrollTop: videoContainerParent.offset().top
			}, 500);
		}); // Slide down the video container
	});

	// Close button functionality
	$(".close-button").on("click", function () {
		var videoContainerParent = $(".video-container-parent");
		var videoContainer = $("#video-container");
		videoContainer.empty(); // Remove the video element
		videoContainerParent.slideUp(300); // Slide up the video container
	});

	$(document).on('click', 'a[play-company-reel]', function (e) {
		console.log('play-company-reel');
		e.preventDefault();
		$.featherlight('<iframe src="https://player.vimeo.com/video/904503525?h=084fc1ba9c&title=0&byline=0&portrait=0&autoplay=1" class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2" style="min-width:50vw; min-height: 360px;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');
		return false;
	});

	function checkVideoPlay() {
		var $video = $('.video-home');
		if ($video.length) {
			var videoTop = $video.offset().top;
			var videoBottom = videoTop + $video.height();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();

			if (videoBottom > viewportTop && videoTop < viewportBottom) {
				// Video is visible
				if (!$video.hasClass('loaded')) {
					$video.addClass('loaded');
					$video[0].load();
				}
				$video[0].play();
			} else {
				// Video is not visible
				$video[0].pause();
			}
		}
	}
	
	if ($('.video-home').length) {
		//On page load or page scroll
		$(window).on('load scroll', function () {
			checkVideoPlay();
		});
	}


});


// Burger menus
document.addEventListener('DOMContentLoaded', function () {
	// Function to close all menus
	function closeAllMenus() {
		const menus = document.querySelectorAll('.navbar-menu-info, .navbar-menu-products');
		menus.forEach(function (menu) {
			const backdropElement = menu.querySelector('.navbar-backdrop');
			backdropElement.classList.toggle('opacity-0');
			backdropElement.classList.toggle('opacity-50');
			setTimeout(() => {
				// Now toggle 'hidden' after animations are completed.
				backdropElement.classList.toggle('hidden');
			}, 200);

			const navElement = menu.querySelector('nav');
			navElement.classList.toggle('opacity-0');
			navElement.classList.toggle('opacity-100');
			navElement.classList.toggle('-translate-x-12');
			navElement.classList.toggle('translate-x-0');
			setTimeout(() => {
				// Now toggle 'hidden' after animations are completed.
				navElement.classList.toggle('hidden');
			}, 200);
		});

		resetMobMenu();
	}

	// Function to toggle the menu based on the button clicked
	function toggleMenu(target) {
		//closeAllMenus(); // Close all menus before opening a new one
		const menuElement = document.querySelector(`.${target}`);
		if (menuElement) {
			const backdropElement = menuElement.querySelector('.navbar-backdrop');
			backdropElement.classList.toggle('hidden');
			requestAnimationFrame(() => {
				// Toggle opacity classes after ensuring the element is not hidden.
				backdropElement.classList.toggle('opacity-0');
				backdropElement.classList.toggle('opacity-50');
			});
			const navElement = menuElement.querySelector('nav');
			navElement.classList.toggle('hidden');
			requestAnimationFrame(() => {
				// Toggle opacity classes after ensuring the element is not hidden.
				navElement.classList.toggle('opacity-0');
				navElement.classList.toggle('opacity-100');
				navElement.classList.toggle('-translate-x-12');
				navElement.classList.toggle('translate-x-0');
			});
			AOS.refresh();
		}
	}

	// Function to toggle the menu based on the button clicked
	function changeMenuPage(target) {
		console.log('changeMenuPage');
		if (target) {
			const pageElement = document.querySelector(`#${target}`);
			if (pageElement) {
				const mainElement = document.querySelector('#mob-nav-main');
				mainElement.classList.toggle('opacity-0');
				mainElement.classList.toggle('opacity-100');
				mainElement.classList.toggle('-translate-x-12');
				mainElement.classList.toggle('translate-x-0');
				setTimeout(() => {
					// Now toggle 'hidden' after animations are completed.
					mainElement.classList.toggle('hidden');

					pageElement.classList.toggle('hidden');
					requestAnimationFrame(() => {
						// Toggle opacity classes after ensuring the element is not hidden.
						pageElement.classList.toggle('opacity-0');
						pageElement.classList.toggle('opacity-100');
						pageElement.classList.toggle('translate-x-12');
						pageElement.classList.toggle('translate-x-0');
					});
				}, 200);
			}
		} else {
			resetMobMenu();
		}
	}

	function resetMobMenu() {
		//Select .mob-nav-page that does not have hidden
		const currentPage = document.querySelector('.mob-nav-page:not(.hidden)');
		currentPage.classList.toggle('opacity-0');
		currentPage.classList.toggle('opacity-100');
		currentPage.classList.toggle('translate-x-12');
		currentPage.classList.toggle('translate-x-0');
		setTimeout(() => {
			// Now toggle 'hidden' after animations are completed.
			currentPage.classList.toggle('hidden');

			const mainElement = document.querySelector('#mob-nav-main');
			mainElement.classList.toggle('hidden');
			requestAnimationFrame(() => {
				// Toggle opacity classes after ensuring the element is not hidden.
				mainElement.classList.toggle('opacity-0');
				mainElement.classList.toggle('opacity-100');
				mainElement.classList.toggle('-translate-x-12');
				mainElement.classList.toggle('translate-x-0');
			});
		}, 200);
	}

	// Click event listener for mobile menu links
	const menuLinks = document.querySelectorAll('#mob-nav-main a');
	if (menuLinks.length) {
		menuLinks.forEach(function (link) {
			link.addEventListener('click', function () {
				const target = link.getAttribute('data-target');
				if (target) {
					changeMenuPage(target);
				}
			});
		});
	}

	// Click event listener for mobile menu links back
	const menuBackLinks = document.querySelectorAll('.mob-nav-back');
	if (menuBackLinks.length) {
		menuBackLinks.forEach(function (link) {
			console.log(link);
			link.addEventListener('click', function () {
				changeMenuPage();
			});
		});
	}

	// Click event listener for burger buttons
	const burgerButtons = document.querySelectorAll('.navbar-burger-info, .navbar-burger-products');
	if (burgerButtons.length) {
		burgerButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				const target = button.getAttribute('data-target');
				if (target) {
					toggleMenu(target);
				}
			});
		});
	}

	// Click event listeners for close buttons and backdrop
	const closeButtons = document.querySelectorAll('.navbar-close');
	const backdropElements = document.querySelectorAll('.navbar-backdrop');
	if (closeButtons.length || backdropElements.length) {
		closeButtons.forEach(function (closeButton) {
			closeButton.addEventListener('click', function () {
				closeAllMenus(); // Close all menus when a close button is clicked
			});
		});

		backdropElements.forEach(function (backdrop) {
			backdrop.addEventListener('click', function () {
				closeAllMenus(); // Close all menus when the backdrop is clicked
			});
		});
	}

	$(document).on('click','.remove-item-button',function(e) {
		e.preventDefault();
		showLoading();


		const cartId = $(this).data('cart-id'); // Using jQuery's .data() method

		//console.log(cartId);

		// Send the AJAX request using jQuery's .ajax() method
		$.ajax({
			url: '/wp/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'remove_from_cart',
				cart_id: cartId
			},
			success: function (response) {
				//console.log(response);
				// Refresh the page
				//Go to /basket page
				window.location.href = "/basket";
				hideLoading();
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.error('AJAX error:', errorThrown);
				alert('Sorry, something went wrong removing your item.');
			}
		});

		return false;
	});

	$(document).ready(function () {
		$('.update-quantity-button').on('click', function (e) {
			e.preventDefault();
			showLoading();
			const productId = $(this).data('product-id');
			const quantity = $(`.quantity-input[data-product-id="${productId}"]`).val();

			$.ajax({
				url: '/wp/wp-admin/admin-ajax.php',
				type: 'POST',
				data: {
					action: 'update_cart_quantity',
					product_id: productId,
					quantity: quantity
				},
				success: function (response) {
					if (response.success) {
						window.location.href = "/basket";
					} else {
						hideLoading();
						alert('Sorry, something went wrong updating your basket.');
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					alert('Sorry, something went wrong updating your basket.');
					console.error('AJAX error:', errorThrown);
				}
			});
		});
	});

	function showLoading() {
		// Center the screen on the .loader element
		const loader = $('.loader');
		const windowHeight = $(window).height();
		const loaderHeight = loader.outerHeight();
		const scrollTop = loader.offset().top - (windowHeight - loaderHeight) / 2;
		$('html, body').scrollTop(scrollTop);

		$('.loading-screen').removeClass('hidden');

		//Scroll so loading-message is in the center of the screen
		const loadingMessage = $('.loading-message');
		const loadingMessageHeight = loadingMessage.outerHeight();
		const scrollTopMessage = loadingMessage.offset().top - (windowHeight - loadingMessageHeight) / 2;
		$('html, body').scrollTop(scrollTopMessage);

	}

	function hideLoading() {
		$('.loading-screen').addClass('hidden');
	}


	//Flatpickr
	// Check if the flatpickr element exists
	const flatpickrElement = document.querySelector('.checkin-picker');
	if (flatpickrElement) {
		console.log('flatpickr element exists');
		// Create a new flatpickr instance
		flatpickr('.checkin-picker', {
			altInput: true,
			altFormat: 'F j, Y',
			dateFormat: 'Y-m-d',
			minDate: 'today',
			maxDate: new Date().fp_incr(730), // 2 years from now
			locale: {
				firstDayOfWeek: 1
			},
			disableMobile: "true"
		});
	}

	// Initialize Swiper 
	function initHomeSwiper() {
		var swipers = document.querySelectorAll('.hero-swiper-container');

		swipers.forEach(function (swiperContainer) {
			//Find carousel container underneath this

			new Swiper(swiperContainer, {

				modules: [Autoplay, EffectFade, Pagination],
				// Swiper options here
				lazy: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="' + className + '"></span>';
					},
				},
				allowTouchMove: false,
				slidesPerView: 1,
				loop: true,
				speed: 600,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: 5000,
				},
			});
		});
	}
	initHomeSwiper();

	function initCarouselSwiper() {
		var swipers = document.querySelectorAll('.block-carousel');

		swipers.forEach(function (parent) {
			//Find carousel container underneath this
			//Find ..carousel-swiper-container inside parent
			
			var swiperContainer = parent.querySelector('.carousel-swiper-container');

			//Get datta-block-id
			var blockId = parent.getAttribute('data-block-id');

			new Swiper(swiperContainer, {

				modules: [Navigation, Pagination],
				// Swiper options here
				lazy: true,
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
				navigation: {
					nextEl: ".block-" +blockId + " .swiper-next",
					prevEl: ".block-" + blockId + " .swiper-prev",
				},
				allowTouchMove: true,
				slidesPerView: 1,
				breakpoints: {
					768: {
						allowTouchMove: false,
						slidesPerView: 3,
						spaceBetween: 20
					},
				}
			});
		});
	}
	initCarouselSwiper();

	// Initialize Swiper for homepage reviews
	function initReviewsSwiper() {
		var swipers = document.querySelectorAll('.reviews-swiper-container');

		swipers.forEach(function (swiperContainer) {
			//Find carousel container underneath this

			var reviewSwiper = new Swiper(swiperContainer, {

				// Swiper options here
				modules: [Autoplay],
				lazy: true,
				allowTouchMove: true,
				slidesPerView: 1,
				spaceBetween: 32,
				loop: true,
				autoplay: {
					delay: 5000,
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				},
				
			});

			const reviewSliderPrevious = document.getElementById('review-slider-previous')
			const reviewSliderNext = document.getElementById('review-slider-next')

			reviewSliderPrevious.addEventListener('click', () => reviewSwiper.slidePrev() )
			reviewSliderNext.addEventListener('click', () => reviewSwiper.slideNext())


		});
	}
	initReviewsSwiper();

	// Mega Menu
	// Function to toggle the mega menu based on the button clicked
	var menuOpen = false;
	$(document).on('click', 'a[data-menu-id]', function (e) {
		e.preventDefault();
		var menuid = $(this).data('menu-id');

		//$('.mega-menu').addClass('hidden');
		$('.menu-overlay').addClass('hidden');
		


		if ($('.mega-menu[data-menu-id="' + menuid + '"]').hasClass('hidden')) {
			$('.mega-menu').addClass('hidden');
			$('.mega-menu[data-menu-id="' + menuid + '"]').removeClass('hidden');
			$('.menu-overlay').removeClass('hidden');

			console.log('Opening menu: ' + menuid);
		} else {
			$('.mega-menu[data-menu-id="' + menuid + '"]').addClass('hidden');


			console.log('Close menu: ' + menuid);
		}
	});
	$(document).on('click', '.menu-overlay', function (e) {
		e.preventDefault();
		$('.mega-menu').addClass('hidden');
		$('.menu-overlay').addClass('hidden');
	});

	// Check if the cookie is set
	if (document.cookie.split(';').some((item) => item.trim().startsWith('bannerClosed='))) {
		// If the cookie is set, remove the banner
		var banner = document.getElementById('bottom-banner');
		if (banner) {
			banner.remove();
		}
	} else {
		// If the cookie is not set, add a click event listener to the button
		var button = document.querySelector('button[data-dismiss-target="#bottom-banner"]');

		if (button) {
			button.addEventListener('click', function () {
				// When the button is clicked, remove the banner
				var banner = document.getElementById('bottom-banner');
				if (banner) {
					banner.remove();
				}

				// Set a cookie to remember that the banner has been closed
				var date = new Date();
				date.setFullYear(date.getFullYear() + 1); // Cookie expires in 1 year
				document.cookie = 'bannerClosed=true; expires=' + date.toUTCString() + '; path=/';
			});
		}
	}
});

/*$(function () {
	//the shrinkHeader variable is where you tell the scroll effect to start.
	var shrinkHeader = $('#header').height();
	var recentScroll = false;

	$(window).scroll(function () {
		var scroll = getCurrentScroll();
		console.log(recentScroll+' -- '+scroll+' -- '+shrinkHeader);
		if (!recentScroll && (scroll >= shrinkHeader)) {
			console.log('t')
			$('#header').addClass('shadow-header');
			$('#header-logo').removeClass('w-180').addClass('w-110');
			recentScroll = true;
			window.setTimeout(() => { recentScroll = false; $(window).scroll(); }, 200)
		} else if (!recentScroll && (scroll < shrinkHeader)) {
			$('#header').removeClass('shadow-header');
			$('#header-logo').removeClass('w-110').addClass('w-180');
		}
	});
	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}
});*/